<template>
  <div>
    <crypto-traders-table
      @editCryptoTrader="editCryptoTrader"
    />

    <v-dialog
      fullscreen
      hide-overlay
      transition="dialog-bottom-transition"
      scrollable
      persistent
      v-model="isEditCryptoTraderModalVisile"
    >
      <form-edit-crypto-trader
        @close="closeForm"
        :trader="editedCryptoTrader"
        :attendeeTypesList="regularAttendeeTypeData"
      />
    </v-dialog>
  </div>
</template>

<script>
import CryptoTradersTable from './CryptoTradersTable'
import FormEditCryptoTrader from './FormEditCryptoTrader'
import { mapActions, mapGetters } from 'vuex'
import { clone } from 'ramda'

export default {
  name: 'CryptoTraders',
  components: {
    CryptoTradersTable,
    FormEditCryptoTrader
  },
  data () {
    return {
      isEditCryptoTraderModalVisile: false,
      editedCryptoTrader: {},
      regularAttendeeTypeData: []
    }
  },
  computed: {
    ...mapGetters([
      'regularAttendeeType'
    ])
  },
  watch: {
    regularAttendeeType: {
      handler (newVal) {
        this.regularAttendeeTypeData = clone(newVal)
      },
      immediate: true
    }
  },
  methods: {
    ...mapActions([
      'getRegularAttendeeType'
    ]),
    editCryptoTrader(cryptoTrader) {
      this.editedCryptoTrader = clone(cryptoTrader)
      this.isEditCryptoTraderModalVisile = true
    },
    closeForm () {
      this.isEditCryptoTraderModalVisile = false
      this.editedCryptoTrader = {}
    },
    async receiveRequiredData () {
      await this.getRegularAttendeeType()
    }
  },
  mounted () {
    this.receiveRequiredData()
  }
}
</script>



// WEBPACK FOOTER //
// src/components/pages/Registration/Attendee/CryptoTrader/index.vue